import React from "react"
import styled from "styled-components"
import FooterSponsers from "./FooterSponsers"
import FooterMenus from "./FooterMenus"
import FooterText from "./FooterText"
import bg from "images/pattern-black.jpg"
import stonebg from "images/white-stone.jpg"

const SponserBg = styled.div`
    background-image: url("${stonebg}");
`

const FooterBg = styled.div`
    background-image: url("${bg}");
    padding: 1rem 0;

    @media (min-width: 768px) {
        padding: 1rem 2rem 2rem 2rem; 
    }

    @media (min-width: 992px) {
       padding: 1rem 4rem 4rem 4rem; 
    }
`

const Footer = () => {
    return(
        <footer>
            <SponserBg>
                <FooterSponsers />
            </SponserBg>
            <FooterBg>
                <FooterMenus />
                <FooterText />
            </FooterBg>
        </footer>
    )
}

export default Footer